import React from "react";
import { formatMoney } from "../../features/utils/formatMoney";
import PricingSectionShimmer from "../shimmer/PricingSectionShimmer";

function CommonBookingPricingSection({
  loading,
  image,
  productName,
  detail = [],
  items = [],
  total = 0,
  cancellationPolicy = [],
  belowDetail = <></>,
  belowItems = <></>,
  belowCancellation = <></>,
  contain = false,
}) {
  if (loading) {
    return <PricingSectionShimmer />;
  }
  return (
    <div className="flex flex-col flex-1 lg:max-w-md border-2 border-gray-300 bg-white top-4 lg:sticky p-2 sm:p-4 h-fit rounded-lg">
      <>
        <div className="flex flex-col lg:flex-row lg:items-center gap-4 mb-3">
          {image && (
            <img
              src={image}
              alt=""
              className={`w-full lg:w-24 h-56 sm:h-96 lg:h-20 rounded-lg ${
                contain ? "object-contain" : "object-cover"
              }`}
            />
          )}
          <span className="text-xl font-bold">{productName}</span>
        </div>
        {detail
          ?.filter((item) => Boolean(item?.content))
          ?.map((item, index) => (
            <div
              className="flex items-center gap-2 text-gray-500 mb-2"
              key={index}
            >
              {item?.iconNode || (
                <img src={item?.icon} alt="" className="w-4 object-contain" />
              )}
              <span>{item?.content}</span>
            </div>
          ))}
      </>
      {belowDetail}

      <div className="flex w-full justify-between text-sm pb-2 border-b-2 border-b-400 mb-4 mt-4">
        <span className="font-bold text-lg">Price Summary</span>
      </div>
      {items?.map((item, index) => (
        <div
          className="text-lg flex w-full justify-between text-gray-700"
          key={index}
        >
          <span>{item?.name}</span>
          <span>{formatMoney(item?.amount)}</span>
        </div>
      ))}
      {belowItems}
      <div
        className={`font-bold text-lg flex w-full justify-between pb-2 pt-3 border-t-2 border-b-400 ${
          cancellationPolicy?.length ? "mb-4" : ""
        } mt-4`}
      >
        <span>Total:</span>
        <span>{formatMoney(total)}</span>
      </div>
      {cancellationPolicy.map((policy, index) => (
        <div
          className="flex bg-blue-600/10 rounded-md w-full py-4 px-4 flex-col mb-2"
          key={index}
        >
          <span className="text-lg font-bold mb-1">{policy?.title}</span>
          <div className="flex items-center gap-2 text-sm text-gray-600">
            <img
              src="/IconCheckmark1.svg"
              alt=""
              className="w-5 h-5 object-contain"
            />
            <span>{policy?.detail}</span>
          </div>
        </div>
      ))}
      {belowCancellation}
    </div>
  );
}

export default CommonBookingPricingSection;
